export default {
    reset_subuser_auth_title: "Reset Subuser Password",
    reset_subuser_auth_success_message: "User password has been reset successfully",
    reset_subuser_auth_error_message: "User password reset failed",
    reset_subuser_auth_message: "Do you want to reset the user password?",
    reset_subuser_auth_label: "Reset",
};